module.exports = __webpack_public_path__ + "img/char_003.2d4f454c.png";